import type { JobsApi } from '@/features/jobs/api/job-api'
import {
  GeneratePublicAccessTokenRequest,
  InitializeJobTaxDataImportRequest,
} from '@taxfyle/api-internal/internal/measure_one_pb'
import {
  mapMeasureOneExperienceToProtos,
  mapMeasureOneSourceDataToProtos,
  type MeasureOneExperience,
  type WellKnownDocumentTypeShortId,
} from '@/features/jobs/details/tax-type/info-gathering/measure-one/mappers'

export class MeasureOneStore {
  constructor(private readonly _api: JobsApi) {}

  async initializeJobTaxDataImport(
    jobId: string,
    workspaceId: string,
    experience: MeasureOneExperience,
    documentTypes: WellKnownDocumentTypeShortId[],
  ) {
    const request = new InitializeJobTaxDataImportRequest()
      .setJobId(jobId)
      .setWorkspaceId(workspaceId)
      .setExperienceType(mapMeasureOneExperienceToProtos(experience))
      .setSourceDataTypesList(
        documentTypes.map((documentType) =>
          mapMeasureOneSourceDataToProtos(documentType),
        ),
      )

    const response =
      await this._api.measureOne.initializeJobTaxDataImport(request)

    return response.getDataRequestId()
  }

  async generatePublicAccessToken(jobId: string) {
    const request = new GeneratePublicAccessTokenRequest().setJobId(jobId)

    const response =
      await this._api.measureOne.generatePublicAccessToken(request)

    return response.getAccessToken()
  }
}
